/**
 * スケジュール可視性設定の変換ユーティリティ
 * FL-114: 陸送員スケジュール公開範囲設定機能
 */

import { DriverScheduleVisibility } from '../types';

/**
 * データベース値からDriverScheduleVisibility enumに変換
 */
export const convertDbValueToEnum = (
  dbValue: string | null | undefined
): DriverScheduleVisibility => {
  return dbValue === 'all_drivers'
    ? DriverScheduleVisibility.ALL_DRIVERS
    : DriverScheduleVisibility.ADMIN_ONLY;
};

/**
 * DriverScheduleVisibility enumからデータベース値に変換
 */
export const convertEnumToDbValue = (visibility: DriverScheduleVisibility): string => {
  return visibility === DriverScheduleVisibility.ALL_DRIVERS ? 'all_drivers' : 'admin_only';
};
